import { FormEvent, useEffect, useState } from 'react'
import { Alert, Button, Form } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { AdminPageHero } from '@/components/common/AdminPageHero'
import { Field } from '@/components/common/Field'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { useCrmHub } from '@/context/SignalRContext'
import { useAuth } from '@/context/AuthContext'
import { readError } from '@/services/apiClient'
import { loadCustomer, saveCustomerNote, type CustomerDetail } from '@/services/customerService'

export function AddNoteScreen() {
  const { customerId = '' } = useParams()
  const navigate = useNavigate()
  const { session } = useAuth()
  const { notify } = useCrmHub()
  const [customer, setCustomer] = useState<CustomerDetail | null>(null)
  const [note, setNote] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    let cancelled = false
    loadCustomer(customerId)
      .then((row) => { if (!cancelled) setCustomer(row) })
      .catch((caught) => { if (!cancelled) setError(readError(caught)) })
    return () => { cancelled = true }
  }, [customerId])

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await saveCustomerNote(customerId, note)
      await notify('SendNoteAdded', { organisationId: customerId, userId: session?.userId, text: note })
      navigate('/')
    } catch (caught) {
      setError(readError(caught))
      setBusy(false)
    }
  }

  return (
    <>
      <AdminPageHero eyebrow="Workspace / CRM" title="Add note" summary={customer ? customer.name : 'Loading customer'} />
      {!customer && !error && <LoadingSpinner text="Loading customer" size="3x" />}
      {error && <Alert variant="danger">{error}</Alert>}
      {customer && (
        <section className="admin-panel form-panel">
          <Form onSubmit={(event) => void submit(event)}>
            <Field label="Note" type="textarea" value={note} onChange={setNote} required />
            <Button type="submit" disabled={busy}>Save note</Button>{' '}
            <Link className="btn btn-outline-secondary" to="/">Cancel</Link>
          </Form>
        </section>
      )}
    </>
  )
}
